import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, dark = false }) => (
  <span
    data-testid="section-kicker"
    className={`inline-flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.25em] font-bold ${
      dark ? "text-[#C2D3C4]" : "text-[#4A6D56]"
    }`}
  >
    <span className={`h-px w-8 ${dark ? "bg-[#C2D3C4]" : "bg-[#4A6D56]"}`} />
    {children}
  </span>
);
